"use strict";

var _classCallCheck = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));
/**
 * Component for Metaform text field
 */


var MetaformTextFieldComponent =
/*#__PURE__*/
function (_react_1$default$Comp) {
  _inherits(MetaformTextFieldComponent, _react_1$default$Comp);

  /**
   * Constructor
   *
   * @param props component props
   */
  function MetaformTextFieldComponent(props) {
    var _this;

    _classCallCheck(this, MetaformTextFieldComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MetaformTextFieldComponent).call(this, props));
    /**
     * Event handler for field input change
     *
     * @param event event
     */

    _this.onChange = function (event) {
      _this.props.onValueChange(event.target.value);
    };

    _this.state = {};
    return _this;
  }
  /**
   * Component render method
   */


  _createClass(MetaformTextFieldComponent, [{
    key: "render",
    value: function render() {
      if (!this.props.field.name) {
        return null;
      }

      return react_1.default.createElement("input", {
        type: "text",
        placeholder: this.props.field.placeholder,
        id: this.props.fieldId,
        "aria-labelledby": this.props.fieldLabelId,
        name: this.props.field.name,
        title: this.props.field.title,
        required: this.props.field.required,
        readOnly: this.props.formReadOnly || this.props.field.readonly,
        value: this.props.value || "",
        onChange: this.onChange,
        onFocus: this.props.onFocus
      });
    }
  }]);

  return MetaformTextFieldComponent;
}(react_1.default.Component);

exports.MetaformTextFieldComponent = MetaformTextFieldComponent;